// src/App.tsx

import { BrowserRouter, Routes, Route } from 'react-router-dom';
// Assuming your component paths are correct
import { Header, Footer } from '@ssa/phoenix-ui-components';
import React, { Suspense } from 'react';

// Lazy-load pages as micro-frontends
const Home = React.lazy(() => import('@ssa/mfe-home').then(m => ({ default: m.Home })));
const About = React.lazy(() => import('@ssa/mfe-about').then(m => ({ default: m.About })));
const Stores = React.lazy(() => import('@ssa/mfe-stores').then(m => ({ default: m.Stores })));
const Careers = React.lazy(() => import('@ssa/mfe-careers').then(m => ({ default: m.Careers })));

import { contactData } from './data/ContactData'; 
import { copyright, vatNumber } from './data/CopyRightData';
import { careersPageData } from './data/CareersPageData'; 
import { aboutPageData } from './data/AboutPageData';
import { stores } from './data/StoresData';
import { companyName, companyMotto, companyImages, heroImageUrl, companyTextData } from './data/CompanyData';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col bg-white">
        <Header />
        <main className="flex-grow pb-2">
          <Suspense fallback={<div className="p-6">Loading…</div>}>
            <Routes>
            <Route
              path="/"
              element={
                <Home
                  companyName={companyName}
                  companyMotto={companyMotto}
                  companyImages={companyImages}
                  heroImageUrl={heroImageUrl}
                  companyTextData={companyTextData}
                />
              }
            />
            <Route path="/about" element={<About data={aboutPageData} />} />
            <Route path="/stores" element={<Stores stores={stores} />} />
            <Route path="/careers" element={<Careers careersPageData={careersPageData} />} />
            {/* fallback route */}
            <Route path="*" element={<Home companyName={companyName} companyMotto={companyMotto} companyImages={companyImages} heroImageUrl={heroImageUrl} companyTextData={companyTextData} />} />
            </Routes>
          </Suspense>
        </main>
        <Footer contactData={contactData} copyrightText={copyright} vatNumber={vatNumber} />
      </div>
    </BrowserRouter>
  );
}

export default App;